import axios, { AxiosInstance } from "axios";

export const createApiInstance = (baseURL: string): AxiosInstance => {
  return axios.create({
    baseURL: baseURL || process.env.REACT_APP_DEFAULT_BASE_URL || '',
  });
};
